import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { Field } from 'formik';
import debounce from 'lodash/debounce';
import { USER_EXISTS } from 'pages/Staff/StaffgraphQL';
import FormikInputField from 'components/Fields/FormikInputField';
import Loader from 'components/common/Loader';

const CALLING_CODE = 'callingCode';

const PhoneNumberFieldWithValidation = ({
  label,
  name,
  type,
  placeholder,
  disabled = false,
  setUserExists,
  ...rest
}) => {
  const [isUserExists, { loading }] = useLazyQuery(USER_EXISTS, {
    fetchPolicy: 'network-only',
  });
  const [isPhoneUnique, setIsPhoneUnique] = useState(true);
  const [user, setUser] = useState(null);
  // Function to handle phone number validation
  const handlePhoneNumberValidation = async (callingCode, phoneNumber) => {
    if (phoneNumber) {
      try {
        const { data } = await isUserExists({
          variables: {
            callingCode,
            columnName: 'phone',
            value: phoneNumber,
          },
        });
        // console.log('rest values', data, rest.values, phoneNumber, name);
        setUserExists(false);

        if (data?.isUserExists) {
          rest.setFieldValue(name, phoneNumber);
          if (data?.isUserExists?.email === rest?.values?.email) {
            setUser(data?.isUserExists);
            setIsPhoneUnique(true);
          } else {
            setUser(data?.isUserExists);
            setIsPhoneUnique(false);
            setUserExists(true);
          }
        } else {
          // rest.setFieldValue('userExist', false);
          setUser(null);
          setIsPhoneUnique(true);
          // setUserExists(false);
        }
      } catch (error) {
        console.error('Error checking phone number uniqueness:', error);
        rest.setFieldError(
          name,
          'There is an error in validating the phone number.',
        );
        rest.setFieldTouched(name, true, true);
      }
    } else {
      setIsPhoneUnique(true);
      // rest.setFieldError(name, rest.errors[name]);
      // rest.validateForm();
    }
  };

  const debouncedValidation = debounce((callingCode, phoneNumber) => {
    handlePhoneNumberValidation(callingCode, phoneNumber);
  }, 500);
  const handleChange = (e) => {
    rest.setFieldValue(name, e.target.value);
    debouncedValidation(
      rest.values[CALLING_CODE][CALLING_CODE],
      e.target.value,
    );
  };
  // useEffect(() => {
  //   if (!rest.errors[CALLING_CODE] && !rest.errors[name]) {
  //     debouncedValidation(
  //       rest.values[CALLING_CODE][CALLING_CODE],
  //       rest.values[name]
  //     );
  //   }
  // }, [rest.values[name]]);

  return (
    <div>
      <Field
        disabled={!rest.values[CALLING_CODE] || disabled}
        label={label}
        name={name}
        type={type}
        placeholder={placeholder}
        component={FormikInputField}
        onChange={handleChange}
      />
      {loading && <Loader />}
      {!isPhoneUnique && user && (
        <div className="text-danger f-12 phone-err mb-3 text-nowrap">
          Phone number already exists.
        </div>
      )}
    </div>
  );
};

export default PhoneNumberFieldWithValidation;
